import React, { forwardRef } from "react";
import { FieldTypes, urlRegexValidator } from "utils/formUtils";
import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import IriusRiskMappingForm from "./IriusRiskMappingForm";

function IriusRiskCredentialsForm(props, ref) {
  const fields = [
    {
      name: "apiEndpoint",
      label: "API Endpoint",
      required: true,
      rules: [urlRegexValidator],
    },
    {
      name: "apiKey",
      label: "API Key",
      type: FieldTypes.PASSWORD,
      required: true,
    },
  ];

  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      fields={fields}
      MappingForm={IriusRiskMappingForm}
    />
  );
}

export default forwardRef(IriusRiskCredentialsForm);
